export default {
	loading: false,
	packageTypes: [],
	palletPackageTypes: [],
	errors: {
		id: '',
		name: false,
		description: false
	}
};